import { useCallback, useMemo } from 'react';
import { useConversationsAttributes } from '@/entities/conversations';
import { useSettings } from '@/entities/settings';
import { SAMPLE_COLUMNS } from './sampleColumns';

export const useSampleAttributesSettings = () => {
  const { data: { attributes = [] } = {}, isLoading: isLoadingAttributes } = useConversationsAttributes({
    'is-deleted': false,
    limit: 1000,
  });

  const { samplesPage, setSamplesSettings } = useSettings();
  const visibleColumns = samplesPage?.visibleColumns ?? [];

  const mainColumnValues: string[] = Object.values(SAMPLE_COLUMNS);

  const selectedPaths = useMemo(
    () => visibleColumns.filter((col) => !mainColumnValues.includes(col)),
    [visibleColumns, mainColumnValues],
  );

  const selectAttributes = useCallback(
    (paths: string[]) => {
      const mainColumns = visibleColumns.filter((col) => mainColumnValues.includes(col));
      setSamplesSettings({ visibleColumns: [...mainColumns, ...paths] });
    },
    [setSamplesSettings, visibleColumns, mainColumnValues],
  );

  const selected = useMemo(
    () => attributes.filter((attr) => selectedPaths.includes(attr.path)),
    [attributes, selectedPaths],
  );

  return {
    selected,
    selectedPaths,
    selectAttributes,
    attributes,
    isLoadingAttributes,
  };
};
